exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-PaperTrading-___charts__wrapper___1E-2j{min-height:370px}.src-components-PaperTrading-___charts__spin___11bHx{background:white}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-PaperTrading-___charts__wrapper___1E-2j",
	"spin": "src-components-PaperTrading-___charts__spin___11bHx"
};